#@import Backbone
#@export Booking.Models.Base

class Booking.Models.Base extends Backbone.Model

  constructor: ->
    Backbone.Model.apply this, arguments

    if typeof @error is 'function'
      @on 'error', @error, this

  sync: (method, model, options) ->
    beforeSend = (xhr) ->
      xhr.setRequestHeader('x-csrf-token', Booking.csrf) if Booking.csrf
      xhr.setRequestHeader('x-auth-token', Booking.authToken) if Booking.authToken

    options = _.extend({}, options, {beforeSend})

    Backbone.Model::sync.call(this, method, model, options)

